(function () {
    'use strict';

    angular.module("imApp").factory("guardListService", ['$ihttp', function ($ihttp) {
        let service = {
            listGuards: function (parms) {
                return $ihttp.post({
                    method: 1649,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
